import { ArrowLeft, Pencil } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

import { Button } from '@/components/ui/catalyst/button';

import { TemplateView } from './TemplateView';

export const TemplateDetailPage = () => {
  const { demand_example_id, template_id } = useParams<{
    demand_example_id: string;
    template_id: string;
  }>();
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(
      `/demand-examples/${demand_example_id}/templates/${template_id}/edit`,
    );
  };

  if (!demand_example_id || !template_id) {
    return <p className="text-sm text-red-500 p-4">Missing template id.</p>;
  }

  return (
    <div className="p-4 flex flex-col gap-4 h-full">
      <div className="flex items-center gap-2">
        <Button
          plain
          onClick={() => navigate(-1)}
          aria-label="Back"
          className="flex items-center gap-1"
        >
          <ArrowLeft className="h-4 w-4" /> Back
        </Button>
        <h2 className="text-lg font-semibold flex-1">Template Details</h2>
        <Button
          onClick={handleEdit}
          className="flex items-center gap-1"
          aria-label="Edit template"
        >
          <Pencil className="h-4 w-4" /> Edit
        </Button>
      </div>
      <TemplateView
        demandExampleId={demand_example_id}
        templateId={template_id}
      />
    </div>
  );
};
